// The purpose of this function is to identify if an event (like a click) that has occurred inside a larger container (like a div)
// actually took place on a specific set of inner elements (button, a, img, textarea).
// If the event did occur on these inner elements, the function would return true,
// indicating that some kind of inner event propagation prevention may be desired in the caller's context.
// Otherwise, it returns false.
// How? It compares the closest relevant ancestors of the target to a list of those inner elements from the container, returning true if a match is found
// Why? This is useful for preventing inner events from triggering outer events, like a click on a button inside a div triggering a click on the div.

export function preventInnerEventPropagation(event: Event): boolean {
  if (!(event.target instanceof HTMLElement && event.currentTarget instanceof HTMLElement)) {
    return true;
  }

  const innerButtons = event.currentTarget?.getElementsByTagName("button");
  const innerLinks = event.currentTarget.getElementsByTagName("a");
  const innerImages = event.currentTarget.getElementsByTagName("img");
  const innerTextArea = event.currentTarget.getElementsByTagName("textarea");
  const closestButton = event.target.closest("button");
  const closestLink = event.target.closest("a");
  const closestImg = event.target.closest("img");
  const closestTextArea = event.target.closest("textarea");

  if (
    (closestButton && [...innerButtons].includes(closestButton)) ||
    (closestLink && [...innerLinks].includes(closestLink)) ||
    (closestImg && [...innerImages].includes(closestImg)) ||
    (closestTextArea && [...innerTextArea].includes(closestTextArea))
  ) {
    return true;
  }
  return false;
}
